// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/store.js";
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import {description} from '../package.json'

Vue.use(ElementUI);
Vue.use(VueMoment, {
  moment,
});
//启动时的生产提示
Vue.config.productionTip = false;
// axios
import axios from "axios";
import Qs from "qs";
axios.defaults.transformRequest = [function (data) {
  if (data.toString() == "[object FormData]") {
    return data;
  } else {
    return Qs.stringify(data)
  }
}];
let initApp = function () {

  const instance = axios.create({
    baseURL: localStorage.lineUrl,
    timeout: 10000,
    withCredentials: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    }
  });
  Vue.prototype.$http = instance;

  sessionStorage.removeItem('lineUrl')

  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  });

  router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
  });
}
let Line_1 = process.env.Line_1;//"https://server3299.hk99666.com/";
let Line_2 = process.env.Line_2;//"https://server3299.hk99111.com/";

Vue.prototype.$URLs = [{ "id": 1, "name": "线路一", "url": process.env.API_ROOT }, { "id": 2, "name": "线路二", "url": Line_1 }, { "id": 3, "name": "线路三", "url": Line_2 }];
// Vue.prototype.$chatApiURL = "http://localhost:9080";
// Vue.prototype.$chatApiURL = "https://chatapp.hk9999z.com/";
Vue.prototype.$chatApiURL = "https://chat.hk99555.com";
let lines = Vue.prototype.$URLs;

let workingLines = [];

let checkLine = function (url) {
  return new Promise((resolve, reject) => {
    if(url === null || url === undefined){reject();return;};
    fetch(url, { mode: 'no-cors' })
      .then(response => {
        resolve();
      })
      .catch(error => {
        reject();
      });
  });
}

let lineSelectPromise = new Promise((resolve, reject) => {
  lines.forEach((value, index, array) => {
    let startTime = new Date().getTime();
    fetch(value.url, { mode: 'no-cors' })
      .then(response => {
        let endTime = new Date().getTime();
        let elapsedTime = endTime - startTime;
        let item = {};
        item.time = elapsedTime;
        item.url = value.url;
        item.name=value.name;
        item.id=value.id;

        workingLines.push(item);
        if (index === array.length - 1 || workingLines.length > 1) resolve();

      })
      .catch(error => {
        if (index === array.length - 1) resolve();
      });
  })
})

//continue with current api line if it's working
let storedLine = sessionStorage.lineUrl;

checkLine(storedLine).then(() => {
  initApp();
}).catch(() => {
  lineSelectPromise.then(res => {
    setTimeout(() => {
    console.log(workingLines);
    workingLines.sort((a, b) => (a.time > b.time) ? 1 : -1)
    let lineURL = workingLines[0].url ;
    let lineURLText = workingLines[0].name ;
    let lineUrlId = workingLines[0].id;
      localStorage.setItem('lineUrl', lineURL);
      sessionStorage.setItem('lineUrl',lineURL);
      localStorage.setItem('lineUrlText', lineURLText);
      sessionStorage.setItem('lineUrlText',lineURLText);
      localStorage.setItem('lineUrlId', lineUrlId);
      sessionStorage.setItem('lineUrlId',lineUrlId);
    initApp();
    },1000);
  })
})
  







// WEBPACK FOOTER //
// ./src/main.js